// Backend shares the page origin (Caddy routes /socket.io, /api); override only for local dev.
export const SERVER_URL = (process.env.REACT_APP_SERVER_URL || window.location.origin).replace(/\/+$/, '');
export const SIGNAL_SERVER_URL = SERVER_URL;

export const SOCKET_OPTIONS = {
  transports: ['websocket'],
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  reconnectionAttempts: Infinity,
  timeout: 20000,
};

export const DEFAULT_VOLUME = 0.55;
export const MAX_RECONNECT_ATTEMPTS = 5;
export const HEALTH_CHECK_INTERVAL = 30000;
export const STALE_VIDEO_THRESHOLD = 45000;
export const STALE_CHECK_INTERVAL = 10000;
export const UNIT_STALE_TIMEOUT = 15000; // Remove units with no activity for 15 seconds

// Unit metadata comes from unauthenticated senders, so it must never choose a media URL.
// All live video arrives over mediasoup; the HLS path is intentionally disabled.
export const getHlsUrl = () => null;

export const generateViewerId = () =>
  'viewer-' + Math.random().toString(36).substring(2, 9);
